module.exports = __webpack_public_path__ + "img/product.b64f5ef1.png";